import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types';

const REFRESH_TOKEN_KEY = 'printit_rt';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  accessToken: string | null;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  accessToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setTokensAndUser: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string; user?: User }>
    ) => {
      state.accessToken = action.payload.accessToken;
      if (action.payload.user) {
        state.user = action.payload.user;
        state.isAuthenticated = true;
      }
      localStorage.setItem(REFRESH_TOKEN_KEY, action.payload.refreshToken);
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.accessToken = null;
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    },
  },
});

export const { setUser, setAccessToken, setTokensAndUser, clearUser } = authSlice.actions;
export { REFRESH_TOKEN_KEY };
export default authSlice.reducer;
